// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://dysiqkicxwiusdzijtct.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImR5c2lxa2ljeHdpdXNkemlqdGN0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDI2ODA5ODYsImV4cCI6MjA1ODI1Njk4Nn0.jF8RLFV-z4TDM-ZRoHZ1RsN_T98SbJk-KK-_3cv2ILY";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);